import React from 'react';
import { ExternalLink, MessageSquare } from 'lucide-react';

const GOOGLE_REVIEW_URL = 'https://g.page/r/CUoiEUaBbA0XEBM/review';

export default function GoogleReviewInvite() {
  return (
    <section
      aria-label="Share your Chuko Logic experience"
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <div className="flex items-start gap-3">
        <MessageSquare className="w-6 h-6 text-blue-700 mt-1 flex-shrink-0" />
        <div>
          <h3 className="text-xl font-semibold text-gray-900">
            Tell us about your experience
          </h3>
          <p className="text-sm text-gray-600 mt-2">
            Thank you for choosing Chuko Logic. If you'd like to share your
            experience, you can leave a public review on Google.
            Reviews are optional and are not connected to approval or payment.
          </p>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 px-5 py-3 rounded-lg bg-blue-700 text-white font-semibold hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Leave a Google Review
            <ExternalLink className="w-4 h-4" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
